<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Add Contact</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="contact.name" />
          </div>
          <div class="form-group">
            <label>Phone Number</label>
            <vue-tel-input
              :onlyCountries="['US']"
              :validCharactersOnly="true"
              @input="updatePhoneData"
              v-model="contact.phone_number"
            ></vue-tel-input>
          </div>
          <div class="form-group">
            <label for="txtEmail">Email</label>
            <input type="email" class="form-control" id="txtEmail" v-model="contact.email" />
          </div>
          <div class="form-group">
            <label>Receives:</label>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="contact.daily_device_report"
                id="chkDailyDeviceReport"
              />
              <label
                class="form-check-label"
                for="chkDailyDeviceReport"
              >Daily device reports (Email Only)</label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="contact.device_fail_reg_notification"
                id="chkDeviceFailedRegistrationNotification"
              />
              <label
                class="form-check-label"
                for="chkDeviceFailedRegistrationNotification"
              >Device failed registration notifications</label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="contact.all_alerts_sms"
                id="chkAllAlertsSMS"
              />
              <label class="form-check-label" for="chkAllAlertsSMS">All alerts SMS</label>
            </div>
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'AdminContactsIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'admin-contacts-add',
  data: function () {
    return {
      contact: {
        contact_id: 0,
        name: '',
        phone_number: '',
        phone_number_data: {},
        email: '',
        daily_device_report: true,
        device_fail_reg_notification: true,
        all_alerts_sms: true
      }
    }
  },
  computed: {
    ...mapGetters({
      logged_in_user: 'loggedInUser'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
  },
  methods: {
    submit () {
      if (this.contact.phone_number_data.number !== undefined) {
        this.contact.phone_number = this.contact.phone_number_data.number.replace(
          /\s/g,
          ''
        )
      }
      this.$store.dispatch('addEditContact', this.contact)
    },
    updatePhoneData (num, data) {
      if (data.isValid || _.isEmpty(data.number)) {
        this.contact.phone_number_data = data
      }
    }
  }
}
</script>

<style scoped>
</style>
